import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as form } from 'redux-form';
import { notificationsReducer as notifications } from 'virtues-bootstrap';
import { reducer as modal } from 'redux-modal';

import { authLogout } from 'store/actionCreators/auth';
import history from '../../history';

import auth from './auth';
import newestObservations from './newestObservations';
import newReport from './newReport';
import organization from './organization';
import organizations from './organizations';
import patientEngagement from './patientEngagement';
import patientQuestionnaireResponse from './patientQuestionnaireResponse';
import patients from './patients';
import patientsData from './patientsData';
import practitioners from './practitioners';
import questionnaireResponses from './questionnaireResponses';
import reports from './reports';
import resources from './resources';
import user from './user';
import cardiovascularInvestigations from './cardiovascularInvestigations';
import tachyReport from './tachyReport';
import dictionary from './dictionary';

const appReducer = combineReducers({
  auth,
  form,
  modal,
  newestObservations,
  newReport,
  notifications,
  organization,
  organizations,
  patientEngagement,
  patientQuestionnaireResponse,
  patients,
  patientsData,
  cardiovascularInvestigations,
  questionnaireResponses,
  reports,
  practitioners,
  resources,
  router: connectRouter(history),
  user,
  tachyReport,
  dictionary,
});

const rootReducer = (state, action) => {
  if (action.type === authLogout.toString()) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
